import { render, staticRenderFns } from "./DocIndex.vue?vue&type=template&id=43cb531b&"
import script from "./DocIndex.vue?vue&type=script&lang=js&"
export * from "./DocIndex.vue?vue&type=script&lang=js&"
import style0 from "./DocIndex.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports